"use client"

import styled, { css } from "styled-components"

import { getLabelStyles } from "@/design/Label"
import { Input as BaseInput } from "@/design/tsr-ui/components"

export const Input = styled(BaseInput)`
  ${({ theme }) => {
    const { borders, spaces, colors } = theme
    const { size } = theme.fonts
    const { primary, radius } = borders

    return css`
      label {
        ${getLabelStyles}
      }

      input {
        border: ${primary.inline};
        padding: ${spaces.extraSmall} ${spaces.xtrasmall} ${spaces.extraSmall} ${spaces.xtrasmall};
        border-radius: ${radius.extraSmall};
        color: ${colors.content.fg};
        font-size: ${size.input};
      }

      span {
        background-color: transparent;
      }

      &[data-has-error="true"] > :last-child {
        margin-top: ${spaces.xxs};
        margin-left: ${spaces.xs};
      }
    `
  }}
`
